<template>
  <RevInfoBlock
    v-if="shouldDisplay"
    :content="i18n(translations.content)"
    :icon="IconWarning"
    :title="i18n(translations.title)"
    variant="danger"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CartResponse } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './UnavailableCountry.translations'

const props = defineProps<{
  country: CartResponse['addressList']['deliver']['country']
  shippableCountries: CartResponse['shippableCountries']
}>()

const i18n = useI18n()

const shouldDisplay = computed(() => {
  // When the customer has no pre-defined address (i.e.: new user)
  if (!props.country) {
    return false
  }

  return !props.shippableCountries.some(
    ({ countryCode }) => countryCode === props.country,
  )
})
</script>
